import { render, staticRenderFns } from "./StoreProductList.vue?vue&type=template&id=167928f5&scoped=true&"
import script from "./StoreProductList.vue?vue&type=script&lang=js&"
export * from "./StoreProductList.vue?vue&type=script&lang=js&"
import style0 from "./StoreProductList.vue?vue&type=style&index=0&id=167928f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167928f5",
  null
  
)

export default component.exports